var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZarFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35.841V9.176l19.854 13.333L-.01 35.84H0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.543 45.008 22.289-14.994h31.657V45H13.543v.009Z",
    fill: "#00C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 0h55.37v15.011H35.822S12.409-.149 12.119.002Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.625v3.55L19.854 22.5-.01 35.84v3.542l25.004-16.875L-.009 5.625H0Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.625V0h8.349L34.82 17.93h32.677v9.157H34.821L8.341 45H0v-5.616l24.995-16.875L.008 5.625H0Z",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34 0h5.203l22.289 15.003H67.49v2.926H34.82L8.341.01V0Zm0 45.008h5.203l22.289-14.994H67.49v-2.918H34.82L8.341 45v.009Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZarFlag);
export default __webpack_public_path__ + "static/media/zar-flag.62d057fe119fd587e160a1c0ab9ee168.svg";
export { ForwardRef as ReactComponent };